import {
  alertColor,
  darkModeModalBackgroundColor,
  darkModeTextColor,
  flDangerBorder,
  warningText,
} from "constants/colors";
import styled, { css } from "styled-components/macro";

export const RETROTAG_POPPER_WIDTH = 310;
export const RETROTAG_POPPER_HEIGHT = 240;

export const PopperContentStyles = styled.div<{
  $isDarkMode: boolean;
  $isTimelineExpanded?: boolean;
}>`
  font-family: Roboto;
  text-align: center;
  display: flex;
  flex-direction: column;
  align-items: center;
  .paper {
    letter-spacing: 0.02em;
    position: relative;
    background-color: ${({ $isDarkMode }) =>
      $isDarkMode ? darkModeModalBackgroundColor : "white"};
    color: ${({ $isDarkMode }) => ($isDarkMode ? darkModeTextColor : "black")};
    box-sizing: border-box;
    width: ${RETROTAG_POPPER_WIDTH}px;
    border-radius: 5px;
    padding: 25px 35px 10px;
    height: ${RETROTAG_POPPER_HEIGHT}px;
    box-shadow: ${({ $isTimelineExpanded }) =>
      $isTimelineExpanded ? "0 4px 12px rgba(0, 0, 0, 0.15)" : "none"};
  }
  .durationDisplay,
  .startEndTimesDisplay {
    color: ${({ $isTimelineExpanded }) =>
      $isTimelineExpanded ? "#333" : "white"};
    background-color: ${({ $isTimelineExpanded }) =>
      $isTimelineExpanded ? "rgba(255, 255, 255, 0.95)" : "transparent"};
    padding: ${({ $isTimelineExpanded }) =>
      $isTimelineExpanded ? "4px 10px" : "0"};
    border-radius: ${({ $isTimelineExpanded }) =>
      $isTimelineExpanded ? "4px" : "0"};
    box-shadow: ${({ $isTimelineExpanded }) =>
      $isTimelineExpanded ? "0 2px 8px rgba(0, 0, 0, 0.12)" : "none"};
    margin: ${({ $isTimelineExpanded }) =>
      $isTimelineExpanded ? "2px 0" : "0"};
  }
  .durationDisplay {
    margin: 8px 0;
  }
  .startEndTimesDisplay {
    font-size: 14px;
    max-width: 100vw;
    flex-wrap: wrap;
    justify-content: center;
  }
  .editRangeButton {
    text-transform: none;
    padding: 0 9px;
    margin: 8px 0 8px;
    svg {
      height: 0.8em;
    }
    color: ${({ $isTimelineExpanded }) =>
      $isTimelineExpanded ? "white" : "inherit"};
    box-shadow: ${({ $isTimelineExpanded }) =>
      $isTimelineExpanded ? "0 2px 8px rgba(0, 0, 0, 0.15)" : "none"};
  }
  .MuiIconButton-root {
    color: white;
  }
  .editStartEndTimes {
    display: flex;
    gap: 0.5em;
    color: white;
    align-items: center;
  }
  .error {
    color: ${flDangerBorder};
    margin-top: 0.5em;
  }
  ${({ $isDarkMode }) =>
    $isDarkMode &&
    css`
      .MuiIconButton-label svg path {
        fill: ${darkModeTextColor};
      }
      .label {
        color: ${darkModeTextColor};
      }
    `}
  .bottomButtons button {
    text-transform: none;
  }
`;

export const SubmittedPageStyles = styled.div`
  /* margin: auto; */
  width: fit-content;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  .MuiSvgIcon-fontSizeLarge {
    font-size: 3.5rem;
  }
  .MuiSvgIcon-colorPrimary {
    color: #f19e4c;
  }
  .MuiSvgIcon-colorSecondary {
    color: ${alertColor};
  }
  .feedbackText {
    margin: 10px;
    font-family: GothamMedium;
    font-style: normal;
    font-weight: normal;
    font-size: 15px;
    line-height: 18px;

    display: flex;
    align-items: center;
    text-align: center;
    letter-spacing: 0.02em;
  }
  .errorMsg {
    font-size: 12px;
    text-align: center;
    padding: 0 10px;
  }
`;

export const FormPageStyledForm = styled.form<{
  $isDarkMode: boolean;
}>`
  .formTitle {
    font-family: Open Sans;
    font-weight: bold;
    font-size: 17px;
  }
  .formDescription {
    font-size: 14px;
    line-height: 125%;
    .boldText {
      font-weight: bold;
    }
    .warning {
      margin-top: 5px;
      color: ${warningText};
    }
  }
  .btnClose {
    position: absolute;
    top: -10px;
    right: -10px;
    ${({ $isDarkMode }) =>
      $isDarkMode
        ? css`
            color: white;
          `
        : ""}
  }
  .bottomButtons {
    position: absolute;
    bottom: 10px;
    left: 0;
    right: 0;
  }
  .MuiButton-root {
    &.cancelButton {
      color: #c5c5c5;
      padding: 6px 30px;
      &:hover {
        opacity: 1;
      }
    }
    &.confirmButton {
      padding: 6px 30px;
    }
  }
  .MuiButtonBase-root.Mui-disabled {
    opacity: 0.3;
  }
  .MuiButton-root {
    text-transform: none;
  }
`;
